<template>
  <div>
    <div class="fr-item fr-item-1 col">
      <div class="fr-item-data-wrap mr-2">
        <span class="fr-item-data">
          <strong>{{ student.fullName }}</strong>
        </span>
        <span class="fr-item-data">{{ student.impediment }}</span>
        <span class="fr-item-data">
          {{ student.schoolCode }} - {{ student.schoolName }}
        </span>
        <span id="spStudentSie" class="fr-item-data">
          SIE- {{ student.studentId }}
        </span>
        <span class="fr-item-data white-gray">
          Estatus- {{ student.status }}
        </span>
      </div>
      <div class="fr-item-search right-box-button">
        <button id="btnSelectStudent" class="btn-green mr-3" @click="select()">
          <span>Seleccionar</span>
        </button>
        <button
          v-show="student.existsContingency && student.existsLocally"
          id="btnViewStudent"
          data-target="#custommodal"
          data-toggle="modal"
          data-backdrop="static"
          style="width:85px;height:38px;"
          class="btn-green-border"
          @click="SetStudentinfo(student)"
        >
          <i class="fas fa-search" />
          <span class="ml-1">Ver</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/index';
import mixAlert from '@/mixin/alert.mixin';

import StudentStatuses from '@/utils/constants/student/studentStatuses';

export default {
  mixins: [mixAlert],
  props: ['student'],
  data() {
    return {
      IsStudentSet: store.getters['$_student/StudentSie']      
    };
  },  
  computed: {
    isStudentSet() {
      return store.getters['$_student/StudentSie'];
    },
  },
  watch: {
    isStudentSet(newValue) {
      this.IsStudentSet = newValue;
    },
  },
  methods: {    
    select() {
      let selectedStudentMustHaveRegistration =
        store.getters.SelectedStudentMustHaveRegistration;

      let canSelect =
        !selectedStudentMustHaveRegistration ||
        (selectedStudentMustHaveRegistration &&
          this.student.statusId != null &&
          this.student.statusId != StudentStatuses.Disponible);

      if (canSelect) {
        this.$emit('select-student', this.student);
        //store.commit('$_student/setNavigationToViewDisplay', true);
      } else {
        this.ShowToast(
          'Alerta',
          'El estudiante no cuenta con un registro para el programa de Educación Especial.',
          'error'
        );
      }
    },
    async SetStudentinfo(data) {

      let canAccess = this.student.canAccess;
      
      if (!canAccess)       
      {
        this.$emit('select-student', this.student);
        return;      
      } 

      await store.dispatch('$_student/setStudentDetails', {
            studentId: data.studentId,
            data,
            selectThisStudent: false,
          });
      this.$emit('showStudentInfo', data.studentId);
      store.commit('$_student/ChangeStatusModal', data.studentId);
      store.commit('$_student/setNavigationToViewDisplay', true);
    },
  },
};
</script>

<style scoped>
.right-box-button {
  margin-right: -10px;
}
.white-gray {
  color: #9ba3ad;
}
</style>
